module.exports = __webpack_public_path__ + "img/bassic-badge.9468f3de.svg";